import {
  IconTrendingUp,
  IconShield,
  IconFileText,
  IconLandmark,
  IconCompass,
} from "./icons";

export const CONTACT_INFO = {
  businessName: "PVM Consultants",
  consultantName: "Manoj Kumar",
  phoneDisplay: "+91 96501 93341",
  callLink: "tel:+919650193341",
  whatsappLink: "https://wa.me/919650193341?text=Hi%20Manoj%2C%20I%27d%20like%20to%20know%20more%20about%20your%20financial%20consulting%20services.",
  email: "pvmconsultants@gmail.com",
  mailLink: "mailto:pvmconsultants@gmail.com",
  addressLines: ["F-824, Sector-3, Vaishali", "Ghaziabad, Uttar Pradesh, India"],
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Contact Us", path: "/contact" },
];

export const HERO_STATS = [
  { value: "20+", label: "Years of Experience" },
  { value: "₹5 Cr+", label: "Assets Currently Managed" },
  { value: "1-on-1", label: "Personal Portfolio Management" },
];

export const SERVICE_CONTENT = [
  {
    icon: IconTrendingUp,
    title: "Investment Toolkit",
    description:
      "Explore a range of financial solutions with our trusted partner Prabhudas Liladhar. From mutual funds and stock trading to hassle-free Demat services, we make investing simple and secure.",
  },
  {
    icon: IconShield,
    title: "Insurance Safeguard",
    description:
      "Comprehensive insurance solutions from trusted providers like Bajaj, ICICI, and HDFC. From health and motor to property and travel, we offer coverage for every need, ensuring a hassle-free claims process.",
  },
  {
    icon: IconFileText,
    title: "Hassle-Free Tax Service",
    description:
      "Your go-to partner for effortless tax filing. Whether it's income tax returns or GST compliance, we make the process simple while helping you save more.",
  },
  {
    icon: IconLandmark,
    title: "Loan Advisory",
    description:
      "Your dedicated support for all loan needs — personal, home, or business. We help you secure the best rates and repayment options with ease.",
  },
  {
    icon: IconCompass,
    title: "Financial Advisory",
    description:
      "Your personalized partner for financial success. We offer tailored strategies to help you and your business grow and achieve lasting goals.",
  },
];

export const ABOUT_CONTENT = {
  intro:
    "Manoj Kumar has spent over 20 years helping working professionals take control of their money — from their first mutual fund to their retirement plan.",
  paragraphs: [
    "Most people juggle a different person for every part of their finances — one for taxes, another for insurance, someone else for stock trading, and no one keeping track of the whole picture. Manoj works differently: he manages your entire financial life personally, so you always have one trusted person who knows your full portfolio and has your back.",
    "He is affiliated with Prabhudas Liladhar for share market trading and Demat services, and works with leading partners across insurance, mutual funds, and lending to make sure you get the right product — not just the one that's easiest to sell.",
    "His clients are mostly working professionals who don't have the time (or interest) to track markets, compare policies, or file their own returns — and would rather have someone they can simply call and trust.",
  ],
  highlights: [
    "20+ years in financial services",
    "Currently manages ₹5 Cr+ in client assets",
    "Affiliated with Prabhudas Liladhar for share market & Demat",
    "Full-service: investments, insurance, tax, loans & advisory",
  ],
};

export const TESTIMONIALS = [
  {
    name: "Amit Sharma",
    role: "Software Engineer",
    quote:
      "I don't have time to track the market or chase paperwork. Manoj ji handles everything — my mutual funds, my ITR, even my dad's insurance renewal. One call and it's sorted.",
  },
  {
    name: "Priya Nair",
    role: "Product Manager",
    quote:
      "What I value most is that he actually explains things instead of just selling a product. My whole portfolio finally feels like it has a plan behind it.",
  },
  {
    name: "Rohit Verma",
    role: "Bank Employee",
    quote:
      "Been with him for years now. From my first SIP to my home loan, he's the one constant person I trust with money decisions.",
  },
];
